<template>
  <div class="rs-listing__filters">
    <div
      class="rs-listing__filters__expandable rs-news-listing__filters__expandable"
    >
      <div class="rs-news-listing__filters__expandable__showingresultsfor">
        <span v-if="searchKeywords">
          <span v-html="strings['Showing results for']" />
          {{ " " }}
          <span
            class="rs-news-listing__filters__expandable__showingresultsfor__keywords"
            >{{ searchKeywords.trim() }}</span
          >
          {{ " " }}
          ({{ fetchedResults.total_posts }})
        </span>
        <span v-else>
          <span v-html="strings['Showing all news']" />
          <span v-if="fetchedResults && fetchedResults.posts">
            ({{ fetchedResults.total_posts }})
          </span>
        </span>
      </div>
      <div class="rs-listing__filters__expandable__search">
        <input
          type="text"
          v-model="localSearchKeywords"
          :placeholder="strings['Keywords']"
          v-on:keyup.enter="onSearchButtonClick"
        />
        <button v-on:click="onSearchButtonClick">
          <svg width="20.001" height="20.001" viewBox="0 0 20.001 20.001">
            <path
              d="M19.863.816,15.121-3.926a.464.464,0,0,0-.332-.137h-.516A8.1,8.1,0,0,0,16.25-9.375,8.124,8.124,0,0,0,8.125-17.5,8.124,8.124,0,0,0,0-9.375,8.124,8.124,0,0,0,8.125-1.25a8.1,8.1,0,0,0,5.312-1.977v.516a.48.48,0,0,0,.137.332l4.742,4.742a.469.469,0,0,0,.664,0l.883-.883A.469.469,0,0,0,19.863.816ZM8.125-3.125a6.248,6.248,0,0,1-6.25-6.25,6.248,6.248,0,0,1,6.25-6.25,6.248,6.248,0,0,1,6.25,6.25A6.248,6.248,0,0,1,8.125-3.125Z"
              transform="translate(0 17.5)"
              fill="#652981"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchKeywords: String,
    fetchedResults: Object,
    strings: Object,
  },
  data() {
    return {
      isExpanded: false,
      localSearchKeywords: null,
    };
  },
  computed: {
    isFiltering() {
      if (this.localSearchKeywords && this.localSearchKeywords.length)
        return true;
      return false;
    },
  },
  watch: {
    searchKeywords(value) {
      this.localSearchKeywords = value;
    },
  },
  mounted() {
    this.localSearchKeywords = this.searchKeywords;
  },
  methods: {
    onSearchButtonClick() {
      this.$emit("search-keywords-change", this.localSearchKeywords);
    },
  },
};
</script>
